// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <detail-view
  :endpoint="endpoint + 'config/settings'"
  name="Configuration"
  noPathId
  permissions="configuration"
  :values="values"
  ></detail-view>
</template>
<script>
import {ENDPOINT} from '@/shared/constants'
import DetailView from 'vue-common/components/DetailView.vue'

export default {
  components: {
    DetailView
  },

  data () {
    return {
      endpoint: ENDPOINT,
      values: [
        {
          name: 'Basic',
          items: [
            [
              {
                name: 'Price Per User',
                value: 'pricePerUser',
                valueType: 'number'
              },
              {
                name: 'Price Per GB',
                value: 'pricePerGB',
                valueType: 'number'
              },
              {
                name: 'Base Price',
                value: 'priceBase',
                valueType: 'number'
              },
              {
                name: 'Storage Base',
                value: 'storageBase',
                valueType: 'number'
              },
              {
                name: 'Storage Per User',
                value: 'storagePerUser',
                valueType: 'number'
              }
            ]
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// Configuration.vue?3b68b3f4